import React from 'react';
import splash1 from './splash1.png'

const SplashScreenOverlay = () => {
        return(
            <div >
                <img src={splash1} style={{ background: "rgba(0, 0, 0, 0.8)",
                                            display: "block",
                                            position: 'fixed',
                                            width: "100%",
                                            height: "100%",
                                            top: 0,
                                            bottom: 0,
                                            "z-index": "999999" }}></img>
            </div>
        )
}

export default SplashScreenOverlay